'use client';
import type { NextPage } from 'next';
import { CircularProgress, Grid2 } from '@mui/material';
import { useRouter } from "next/router";
import React, { useEffect } from "react";

const HomePage: NextPage = () => {
  const router = useRouter();

  useEffect(() => {
    if (!router.isReady) {
      return;
    }
    router.push('/main');
  }, [router]);

  return (
    <Grid2 container height='100%' alignItems='center' justifyContent='center'>
      <CircularProgress/>
    </Grid2>
  );
};

export default HomePage;
